/** Subject-neutral, seekable reveal engine. All state is derived from media time. */
export type FractionSide = { numerator: string; denominator: string; suffix?: string };
export type FractionEquationVisual = { kind: 'fraction-equation'; left: FractionSide; right: FractionSide; cancelCommonFactor?: boolean };
export type TeachingStep = { id: string; text: string; caption: string; startMs: number; endMs: number; inkEndMs?: number; visual?: FractionEquationVisual };
export type TeachingPlan = { steps: TeachingStep[]; durationMs: number };
export function stepProgress(step: TeachingStep, positionMs: number, reduced = false): number {
  if (!Number.isFinite(positionMs) || positionMs < step.startMs) return 0;
  if (reduced || step.endMs <= step.startMs) return 1;
  return Math.max(0, Math.min(1, (positionMs - step.startMs) / (step.endMs - step.startMs)));
}

/** Finish the pen at its spoken phrase; keep the phase/caption active afterward. */
export function inkProgress(step: TeachingStep, positionMs: number, reduced = false): number {
  const endMs=step.inkEndMs===undefined?step.endMs:Math.max(step.startMs,Math.min(step.endMs,step.inkEndMs));
  return stepProgress({...step,endMs},positionMs,reduced);
}
